import Button, { ButtonProps } from "@material-ui/core/Button";
import { Theme } from "@material-ui/core/styles";
import makeStyles from "@material-ui/core/styles/makeStyles";

type IStyleParam = Pick<IParam, "backgroundColor" | "backgroundColorHover" | "textColor">;

const useStyle = makeStyles((theme: Theme) => ({
    root: (props: IStyleParam) => ({
        "&.MuiButton-contained": {
            "&:hover": {
                backgroundColor: props.backgroundColorHover,
                boxShadow: "none",
            },
            backgroundColor: props.backgroundColor,
            color: props.textColor,
        },
        "&.MuiButton-sizeLarge": {
            fontSize: "0.8em",
            lineHeight: "1.16em",
            padding: `${theme.spacing(1.63)}px ${theme.spacing(3.63)}px`,
        },
    }),
}));

interface IParam extends ButtonProps {
    backgroundColor: string;
    backgroundColorHover: string;
    children: string;
    textColor?: string;
}
export const VariantButton = (props: IParam & ButtonProps) => {
    const { backgroundColorHover, children, backgroundColor, textColor, className, ...buttonProps } = props;
    const classes = useStyle({
        backgroundColor,
        backgroundColorHover,
        textColor,
    });

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Button className={`${className} ${classes.root}`} {...buttonProps}>
            {children}
        </Button>
    );
};
